<template>
  <div class="Customer">
    <div class="page-title">{{ title }}</div>
    <div class="flex">
      <div class="inline" style="width: 120px">
        <el-select size="mini" v-model="search_type_flag">
          <el-option :key="0" :value="0" label="전체" />
          <el-option
            v-for="item in customer_type_flag_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="inline ml-default" style="width: 100px;">
        <el-select size="mini" v-model="search_customer_level_id">
          <el-option :key="0" :value="0" label="기계등급" />
          <el-option :key="null" :value="null" label="미등록" />
          <el-option
            v-for="item in table_customer_level"
            :key="item.id"
            :label="item.code"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="inline ml-default" style="width: 100px;">
        <el-select size="mini" v-model="search_customer_glass_level_id">
          <el-option :key="0" :value="0" label="유리등급" />
          <el-option :key="null" :value="null" label="미등록" />
          <el-option
            v-for="item in table_customer_glass_level"
            :key="item.id"
            :label="item.code"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="inline ml-default" style="width: 100px;">
        <el-select size="mini" v-model="search_customer_door_level_id">
          <el-option :key="0" :value="0" label="도어등급" />
          <el-option :key="null" :value="null" label="미등록" />
          <el-option
            v-for="item in table_customer_door_level"
            :key="item.id"
            :label="item.code"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="inline ml-default" style="width: 100px;">
        <el-select size="mini" v-model="search_client_level_id">
          <el-option :key="0" :value="0" label="거래처등급" />
          <el-option :key="null" :value="null" label="미등록" />
          <el-option
            v-for="item in table_client_level"
            :key="item.id"
            :label="item.level"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="inline ml-default" style="width: 100px;">
        <el-select size="mini" v-model="search_foreign_flag">
          <el-option :key="null" :value="null" label="거래처 구분" />
          <el-option key="N" value="N" label="국내" />
          <el-option key="Y" value="Y" label="해외" />
        </el-select>
      </div>
      <div class="inline ml-default">
        <el-button
          type="primary"
          size="mini"
          round
          v-shortkey="['f5']"
          @shortkey.native="handleClickSearch"
          @click="handleClickSearch"
          >검색(F5)</el-button
        >
      </div>
      <div class="search-left-space inline" />
      <div class="inline">
        <el-button size="mini" round @click="handleClickInit">초기화</el-button>
      </div>
    </div>
    <div class="flex mt-default">
      <div class="font-prop inline">거래처</div>
      <div class="inline">
        <el-input
          v-model="search_customer"
          class="input-with-select"
          size="mini"
          placeholder="거래처"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">대표자</div>
      <div class="inline">
        <el-input
          v-model="search_owner"
          class="input-with-select"
          size="mini"
          placeholder="대표자"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">담당자</div>
      <div class="inline">
        <el-input
          v-model="search_charger"
          class="input-with-select"
          size="mini"
          placeholder="담당자"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">비고</div>
      <div class="inline">
        <el-input
          v-model="search_desc"
          class="input-with-select"
          size="mini"
          placeholder="비고"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">코드</div>
      <div class="inline">
        <el-input
          v-model="search_code"
          class="input-with-select"
          size="mini"
          placeholder="코드"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
    </div>
    <div class="flex mt-default">
      <div class="font-prop inline" style="margin-left:12px;">팩스</div>
      <div class="inline">
        <el-input
          v-model="search_fax"
          class="input-with-select"
          size="mini"
          placeholder="팩스"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">
        대표핸드폰
      </div>
      <div class="inline">
        <el-input
          v-model="search_owner_tel"
          class="input-with-select"
          size="mini"
          placeholder="대표핸드폰"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">
        대표전화
      </div>
      <div class="inline">
        <el-input
          v-model="search_tel"
          class="input-with-select"
          size="mini"
          placeholder="대표전화"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">
        사업자번호
      </div>
      <div class="inline">
        <el-input
          v-model="search_crn"
          class="input-with-select"
          size="mini"
          placeholder="사업자등록번호"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="search-left-space inline" />
      <div class="font-prop inline" :style="{ width: labelWidth }">사업장</div>
      <div class="inline">
        <el-input
          v-model="search_address"
          class="input-with-select"
          size="mini"
          placeholder="사업장"
          :style="{ width: searchWidth }"
        >
        </el-input>
      </div>
      <div class="flex-auto align-right">
        <el-button
          icon="fas fa-file-excel fa-lg"
          style="padding: 8px;"
          circle
          @click="handleClickExcel"
        ></el-button>
      </div>
    </div>
    <div class="row-splitter form-area" v-show="form_visible">
      <CustomerForm
        ref="form"
        :data="form_data"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted"
        @close="handleClose"
      />
    </div>
    <div>
      <ATable
        ref="table"
        v-loading="loading"
        buttons-width="250px"
        max-height="774px"
        :data="sortedItems"
        :page-size="40"
        :disable_insert="!has_grant_write"
        hide-top-panel
        border
        @row-click="handleClickRow"
        @clicked-create="handleClickedCreate"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="selection"
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          align="center"
          :width="$width.indexw"
        />
        <el-table-column
          prop="code"
          label="코드"
          width="70"
          sortable="custom"
        />
        <el-table-column
          prop="type_flag"
          label="구분"
          width="90"
          sortable="custom"
          :formatter="resolveTypeFlag"
        />
        <el-table-column
          prop="name"
          label="거래처명"
          min-width="150"
          sortable="custom"
          show-overflow-tooltip
        />
        <el-table-column
          prop="addr"
          label="사업장"
          min-width="200"
          sortable="custom"
          show-overflow-tooltip
        />
        <el-table-column
          prop="owner"
          label="대표자"
          sortable="custom"
          width="85"
          show-overflow-tooltip
        />
        <el-table-column
          prop="owner_tel"
          label="대표핸드폰"
          width="105"
          show-overflow-tooltip
        />
        <el-table-column
          prop="tel"
          label="대표전화"
          width="105"
          show-overflow-tooltip
        />
        <el-table-column prop="fax" label="팩스" width="110" />
        <el-table-column
          prop="bank_account"
          label="계좌정보"
          width="110"
          show-overflow-tooltip
        />
        <el-table-column prop="crn" label="사업자등록번호" width="120">
          <template slot-scope="scope">{{ scope.row.crn | crn }}</template>
        </el-table-column>
        <el-table-column
          prop="conditions"
          label="업태"
          width="70"
          sortable="custom"
          show-overflow-tooltip
        />
        <el-table-column
          prop="item"
          label="종목"
          width="70"
          sortable="custom"
          show-overflow-tooltip
        />
        <el-table-column
          prop="customer_level_id"
          label="기계등급"
          width="95"
          sortable="custom"
          :formatter="resolveCustomerLevelId"
        />
        <el-table-column
          prop="customer_glass_level_id"
          label="유리등급"
          width="95"
          sortable="custom"
          :formatter="resolveCustomerGlassLevelId"
        />
        <el-table-column
          prop="customer_door_level_id"
          label="도어등급"
          width="95"
          sortable="custom"
          :formatter="resolveCustomerDoorLevelId"
        />
        <el-table-column
          prop="client_level_id"
          label="거래처등급"
          width="110"
          sortable="custom"
          :formatter="resolveClientLevelId"
        />
        <el-table-column
          prop="desc"
          label="비고"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            :disabled="selection.length < 1 || !has_grant_write"
            @click="handleClickBulkChange"
            >{{ $t("button.bulk_change") }}</el-button
          >
        </div>
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="400px"
      destroyOnClose
      :title="$t('button.bulk_change')"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
    >
      <CustomerBulkChange
        v-if="dialog_visible"
        :ids="selectionIds"
        :has_grant_write="!has_grant_write"
        @completed="handleCompletedBulkChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import CustomerForm from "./CustomerForm";
import CustomerBulkChange from "./CustomerBulkChange";

export default {
  name: "Customer",
  mixins: [form_container, authority_level],
  components: { CustomerForm, CustomerBulkChange },
  data() {
    return {
      title: this.$t("title.customer"),
      dialog_visible: false,
      form_data: undefined,
      searchWidth: "150px",
      labelWidth: "60px",
      search_type_flag: 0,
      search_customer_level_id: 0,
      search_customer_glass_level_id: 0,
      search_customer_door_level_id: 0,
      search_client_level_id: 0,
      search_foreign_flag: null,
      search_customer: "",
      search_owner: "",
      search_charger: "",
      search_desc: "",
      search_owner_tel: "",
      search_tel: "",
      search_code: "",
      search_crn: "",
      search_address: "",
      search_fax: "",
      selection: [],
      form_visible: false,
      loading: false,
      sortedItems: [],
      sort: { prop: "name", order: "ascending" },
    };
  },
  watch: {
    table_customer: function() {
      this.loadItems();
    },
  },
  computed: {
    ...mapGetters([
      "table_customer",
      "table_customer_level",
      "table_customer_glass_level",
      "table_customer_door_level",
      "table_client_level",
    ]),
    /* 거래처 구분 */
    customer_type_flag_options() {
      return this.system.options.customer_type_flag;
    },
    customerLevelItems() {
      let ret = Object.assign([], this.table_customer_level);
      ret.splice(0, 0, { id: null, code: " " });
      return ret;
    },
    selectionIds() {
      if (this.selection.length < 1) {
        return [];
      }
      return this.selection.map((s) => s.id);
    },
    has_grant_write() {
      return this.isWriteLevel("customer");
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    initData() {
      return {
        id: 0,
        code: "",
        name: "",
        owner: "",
        owner_ssn: "",
        owner_tel: "",
        crn: "",
        conditions: "",
        item: "",
        bank_name: "",
        bank_account: "",
        tel: "",
        tel2: "",
        fax: "",
        delivery_addr_flag: "1",
        zipcode: "",
        addr: "",
        zipcode2: "",
        addr2: "",
        location: "",
        freight_location: "",
        charger: "",
        email: "",
        homepage: "",
        type_flag: 1,
        grade_flag: null,
        customer_level_id: null,
        customer_glass_level_id: null,
        client_level_id: null,
        deal_flag: "Y",
        invoice_flag: "1",
        reference: "",
        desc: "",
        credit_line: null,
        account_id: null,
        foreign_flag: "N"
      };
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      this.form_visible = true;
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data = clone;
      if (this.form_data.crn && this.form_data.crn.trim().length < 1) {
        this.form_data.crn = "";
      }
      this.util.fireResize();
    },
    resolveTypeFlag(row, column, value) {
      return this.system.options.resolve_customer_type_flag(value);
    },
    resolveCustomerLevelId(row, column, cellValue /*, index*/) {
      if (!cellValue) {
        return "";
      }
      let level = this.table_customer_level.find((l) => l.id === cellValue);
      return level ? level.code : "";
    },
    resolveCustomerGlassLevelId(row, column, cellValue /*, index*/) {
      if (!cellValue) {
        return "";
      }
      let level = this.table_customer_glass_level.find(
        (l) => l.id === cellValue
      );
      return level ? level.code : "";
    },
    resolveCustomerDoorLevelId(row, column, cellValue /*, index*/) {
      if (!cellValue) {
        return "";
      }
      let level = this.table_customer_door_level.find(
        (l) => l.id === cellValue
      );
      return level ? level.code : "";
    },
    resolveClientLevelId(row, column, cellValue /*, index*/) {
      if (!cellValue) {
        return "";
      }
      let client_level = this.table_client_level.find(
        (l) => l.id === cellValue
      );
      return client_level ? client_level.level : "";
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    /** 데이터 선택 */
    handleClickRow(data) {
      this.openDialog(data);
    },
    /** 신규 등록*/
    handleClickedCreate() {
      this.form_visible = true;
      this.form_data = this.initData();
    },
    /**  폼 처리 완료 */
    handleCompleted(result) {
      if (!result) {
        return;
      }
      this.handleClose();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickBulkChange() {
      this.dialog_visible = true;
    },
    handleCompletedBulkChange() {
      this.dialog_visible = false;
    },
    handleClickSearch() {
      this.handleSearchWord();
    },
    handleClickExcel() {
      this.$refs.table.handleClickExcel();
    },
    handleClose() {
      this.form_visible = false;
      this.util.fireResize();
    },
    handleSortChange(sort) {
      // if (sort.order) {
      //   this.sort = sort;
      // } else {
      //   this.sortedItems = [];
      //   return;
      // }
      // if (this.filteredItems.length < 1) {
      //   this.sortedItems = [];
      //   return;
      // }
      // let prop = this.sort.prop;
      // this.loading = true;
      // this.$nextTick(() => {
      //   let items = Object.assign([], this.filteredItems)
      //   if (this.sort.order === 'descending') {
      //     items = this.util.quickSort(items, prop, false);
      //   } else {
      //     items = this.util.quickSort(items, prop);
      //   }
      //   this.sortedItems = items;
      //   this.loading = false;
      // });
      if (sort.order) {
        this.sort = sort;
      }
      this.loadItems();
    },
    handleClickInit() {
      this.search_customer = "";
      this.search_owner = "";
      this.search_charger = "";
      this.search_desc = "";
      this.search_owner_tel = "";
      this.search_tel = "";
      this.search_code = "";
      this.search_crn = "";
      this.search_address = "";
      this.loadItems();
    },
    handleSearchWord() {
      this.loadItems();
    },
    loadItems() {
      let items = this.table_customer.filter((item) => {
        // 거래처
        if (
          !(
            this.search_customer === "" ||
            (item.name !== null && item.name.indexOf(this.search_customer) > -1)
          )
        ) {
          return false;
        }
        // 대표자
        if (
          !(
            this.search_owner === "" ||
            (item.owner !== null && item.owner.indexOf(this.search_owner) > -1)
          )
        ) {
          return false;
        }
        // 담당자
        if (
          !(
            this.search_charger === "" ||
            (item.charger !== null &&
              item.charger.indexOf(this.search_charger) > -1)
          )
        ) {
          return false;
        }
        // 비고
        if (
          !(
            this.search_desc === "" ||
            (item.desc !== null && item.desc.indexOf(this.search_desc) > -1)
          )
        ) {
          return false;
        }
        // 코드
        if (
          !(
            this.search_code === "" ||
            (item.code !== null && item.code.indexOf(this.search_code) > -1)
          )
        ) {
          return false;
        }
        // 팩스
        if (
          !(
            this.search_fax === "" ||
            (item.fax !== null && item.fax.indexOf(this.search_fax) > -1)
          )
        ) {
          return false;
        }
        // 대표핸드폰
        if (
          !(
            this.search_owner_tel === "" ||
            (item.owner_tel !== null &&
              item.owner_tel.indexOf(this.search_owner_tel) > -1)
          )
        ) {
          return false;
        }
        // 대표전화
        if (
          !(
            this.search_tel === "" ||
            (item.tel !== null && item.tel.indexOf(this.search_tel) > -1) ||
            (item.tel2 !== null && item.tel2.indexOf(this.search_tel) > -1)
          )
        ) {
          return false;
        }
        // 사업자번호
        if (
          !(
            this.search_crn === "" ||
            (item.crn !== null && item.crn.indexOf(this.search_crn) > -1)
          )
        ) {
          return false;
        }
        // 사업장
        if (
          !(
            this.search_address === "" ||
            (item.addr !== null && item.addr.indexOf(this.search_address) > -1)
          )
        ) {
          return false;
        }
        // 구분
        if (
          !(
            this.search_type_flag === 0 ||
            (item.type_flag !== null &&
              item.type_flag === this.search_type_flag)
          )
        ) {
          return false;
        }
        // 기계등급
        if (
          !(
            this.search_customer_level_id === 0 ||
            (item.customer_level_id !== null &&
              item.customer_level_id === this.search_customer_level_id)
          )
        ) {
          return false;
        }
        // 유리등급
        if (
          !(
            this.search_customer_glass_level_id === 0 ||
            (item.customer_glass_level_id !== null &&
              item.customer_glass_level_id ===
                this.search_customer_glass_level_id)
          )
        ) {
          return false;
        }
        // 도어등급
        if (
          !(
            this.search_customer_door_level_id === 0 ||
            (item.customer_door_level_id !== null &&
              item.customer_door_level_id ===
                this.search_customer_door_level_id)
          )
        ) {
          return false;
        }
        // 거래처등급
        if (
          !(
            this.search_client_level_id === 0 ||
            (item.client_level_id !== null &&
              item.client_level_id === this.search_client_level_id)
          )
        ) {
          return false;
        }
        if (
          !(
            this.search_foreign_flag === null ||
            (item.foreign_flag !== null &&
              item.foreign_flag === this.search_foreign_flag)
          )
        ) {
          return false;
        }
        return true;
      });
      let prop = this.sort.prop;
      if (this.sort.order === "descending") {
        items = this.util.quickSort(items, prop, false);
      } else {
        items = this.util.quickSort(items, prop);
      }
      this.sortedItems = items;
    },
  },
};
</script>
<style lang="scss">
.Customer {
  .search-left-space {
    margin-left: 12px;
  }
  .search-top-space {
    margin-top: 12px;
  }
  .font-prop {
    font-weight: bold;
    font-size: 12px;
    margin-top: 2px;
    margin-right: 10px;
    text-align: right;
  }
}
</style>
